import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './local';

// Detectar idioma del navegador
const getBrowserLanguage = () => {
  const browserLang = navigator.language.toLowerCase();
  
  // Mapear códigos de idioma del navegador a nuestros idiomas soportados
  if (browserLang.startsWith('es')) return 'es';
  if (browserLang.startsWith('en')) return 'en';
  if (browserLang.startsWith('fr')) return 'fr';
  
  // Idioma por defecto
  return 'es';
};

// Obtener idioma guardado o detectar del navegador
const savedLanguage = localStorage.getItem('language');
const defaultLanguage = savedLanguage || getBrowserLanguage();

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLanguage,
  fallbackLng: 'es',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;